import { Button, Typography } from '@smartgift/frontend-toolkit';
import React, { useContext, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { TotalEstimatedSpendModal } from '@hero/components/modals';
import { formatCurrency } from '@hero/utils';

import { EditModalContext } from './context';
import * as S from './style';

function NavigationSecondaryContent() {
  const { t } = useTranslation();
  const [isEstimatedTotalModalOpen, setIsEstimatedModalOpen] = useState(false);
  const { difference } = useContext(EditModalContext);

  return (
    <S.NavigationSecondaryContent>
      <Typography variant="body2Bold">
        <Trans
          i18nKey="youWillChargedX"
          values={{
            price: formatCurrency(difference?.total)
          }}
          components={{
            div: (
              <Typography
                style={{ marginLeft: 8 }}
                color="success"
                variant="stronger"
                as="span"
                emphasis="700"
              />
            )
          }}
        />
      </Typography>
      <Button
        onClick={() => setIsEstimatedModalOpen(true)}
        variant="link"
        color="neutral"
        emphasis="500"
        style={{ textTransform: 'none' }}
      >
        <Typography color="neutral" emphasis="500" variant="caption1">
          {t('howOurPriceWork')}
        </Typography>
      </Button>

      <EditModalContext.Consumer>
        {({ isCCPayment }) => {
          return (
            <TotalEstimatedSpendModal
              isCCPayment={isCCPayment}
              isModalOpen={isEstimatedTotalModalOpen}
              onModalOpen={() => setIsEstimatedModalOpen(false)}
            />
          );
        }}
      </EditModalContext.Consumer>
    </S.NavigationSecondaryContent>
  );
}

export { NavigationSecondaryContent };
